export const defaultAppConfig = {
  app_name: "Recally",
  app_description: "Recally empowers users to effortlessly record meetings or lectures, delivering highly accurate English transcripts and concise AI-generated summaries, all securely stored for on-demand retrieval and contextual chat interaction.",
  app_tagline: "Capture. Transcribe. Understand.",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/c04c1ae8-88a6-4246-a9d2-e6af1a984e4a/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/c04c1ae8-88a6-4246-a9d2-e6af1a984e4a/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/c04c1ae8-88a6-4246-a9d2-e6af1a984e4a/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/c04c1ae8-88a6-4246-a9d2-e6af1a984e4a/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



